import useModal from "@/lib/hooks/useModal";
import { useState } from "react";

const useSearchModal = () => {
	const [mode, setMode] = useState<"searched" | "default">("default");
	const { isOpen, openModal, closeModal, toggleModal } = useModal(
		"searchBar",
		() => {},
		true,
	);

	return {
		isOpen,
		openModal,
		closeModal,
		toggleModal,
		mode,
		setMode,
	};
};

export default useSearchModal;
